import React from 'react';
import type { Filter, FilterDataSearchDynamic } from '@/app/common/filters/core/filtersTypes.ts';
import type { SuggestionFetcher } from '@/app/components/search/components/AutocompleteBasic';
import { type FilterSearchDynamicSelected, FilterSearchDynamicSelector } from './FilterSearchDynamicSelector.tsx';
import {
  FilterSearchDynamicModalCloseStyled,
  FilterSearchDynamicModalHeadingStyled,
  FilterSearchDynamicModalStyled,
  FilterSearchDynamicModalTitleNameStyled,
  FilterSearchDynamicModalTitleStyled,
} from './styled.ts';
import CloseIcon from './CloseIcon.tsx';

type Props = {
  filter: Filter;
  name: string;
  suggestionFetcher: SuggestionFetcher;
  onUpdate: (e: FilterSearchDynamicSelected) => void;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FilterSearchDynamicModal = ({ filter, name, suggestionFetcher, onUpdate, setShowModal }: Props) => {
  const filterData = filter.data as FilterDataSearchDynamic;

  const handleCloseClicked = () => {
    setShowModal(false);
  };
  const handleOnUpdate = (selectedProps: FilterSearchDynamicSelected) => {
    if (selectedProps?.target?.value) {
      setShowModal(false);
    }
    onUpdate(selectedProps);
  };

  return (
    <FilterSearchDynamicModalStyled>
      <FilterSearchDynamicModalHeadingStyled>
        <FilterSearchDynamicModalTitleStyled>
          <FilterSearchDynamicModalCloseStyled onClick={handleCloseClicked}>
            <CloseIcon />
          </FilterSearchDynamicModalCloseStyled>
          <FilterSearchDynamicModalTitleNameStyled>{filterData.label}</FilterSearchDynamicModalTitleNameStyled>
        </FilterSearchDynamicModalTitleStyled>
        <FilterSearchDynamicSelector
          filter={filter}
          name={name}
          suggestionFetcher={suggestionFetcher}
          onUpdate={handleOnUpdate}
        />
      </FilterSearchDynamicModalHeadingStyled>
    </FilterSearchDynamicModalStyled>
  );
};
